var map = {
	"./logo-folddisco_1x.png": 16684,
	"./logo-foldmason_1x.png": 12004,
	"./logo-foldseek_1x.png": 62724,
	"./logo-mmseqs_1x.png": 12425,
	"./logo-riboseek_1x.png": 46901
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 78806;